export const futurIANavigation = [
  {
    group: "Conversazioni",
    links: [
      { label: "Parla con FuturIA", href: "/ai-assistant", icon: "✦" },
      { label: "Chat del team", href: "/team-chat", icon: "◉" },
    ],
  },
  {
    group: "Lavoro",
    links: [
      { label: "Aziende", href: "/aziende", icon: "⌂" },
      { label: "Pratiche", href: "/pratiche", icon: "◷" },
      { label: "Documenti", href: "/documents", icon: "▤" },
      { label: "Progetti condivisi", href: "/progetti", icon: "◇" },
    ],
  },
  {
    group: "Organizzazione",
    links: [
      { label: "Attività", href: "/tasks", icon: "☑" },
      { label: "Calendario", href: "/calendario", icon: "▦" },
    ],
  },
  {
    group: "Strumenti",
    links: [
      { label: "Fonti legali", href: "/fonti-legali", icon: "⚖" },
      { label: "Processi e routine", href: "/processi", icon: "⌘" },
    ],
  },
] as const;
